import _ from 'lodash'
import envConst from '@/env-const.js'
import encrypt from './assets/encrypt'
import * as utils from './assets/utils'
import ws from './assets/ws'
import { system, pages } from '@/router/routes.js'
import stores from '@/store/'
// addMenus方法已被弃用，等模块删除相关引用代码后此代码语句可删除。
import addMenus from './methods/add-menus'
import customDirective from './directive/'
import layout from './layout/'
import commonComponents from '@/components/common'
import getPreData from './getPreData'
import excludeCheckPath from './excludeCheckPath'
// 链接主题样式表，图标字体等文件
import linkStaticFile from './linkStaticFile'
// import styleDemo from '@/views/styleDemo'
// import 'codemirror/lib/codemirror.css'
// import 'codemirror/theme/darcula.css' 
import eventBus1 from './even-bus'
import globalFilter from './assets/filter.js'
import xssFilter from './xssFilter.js';
import echarts from 'echarts'
import addRouter from './assets/addRouter'
// import module_loader from './assets/moduleLoader.js'
import './assets/fontDJB/DJB Get Digital.css'
import frameUtil from './views/iframeview/iframeUtils.js'
export default (ctx) => {
    var { Vue, store, router, app, exclude } = ctx
    //与嵌入页面交互工具
    Vue.prototype.frameUtil = frameUtil(Vue)
    //自定义addroute，去掉配置的嵌套路由，解决tab页缓存问题
    Vue.prototype.$addRoutes = addRouter(ctx)
    // Vue.prototype.$moduleLoader = module_loader(ctx)
    let conf_host = envConst.CONF_HOST
    if(location.origin.indexOf('localhost') > -1){
        conf_host = "//localhost:8010/scconf_ui.umd.min.js"
    }
    app.$moduleLoader([`${conf_host}?${new Date().getTime()}`]).then(()=>{
        console.log('获取配置',store)
        scconf_ui&&(Vue.prototype.$config = scconf_ui(ctx))
    })
    //全局过滤器
    Vue.use(globalFilter)
    Vue.prototype.$eventBus = eventBus1
    Vue.prototype.$_ = _
    Vue.prototype.$utils = utils
        // addMenus方法已被弃用，等模块删除相关引用代码后此代码语句可删除。
    Vue.prototype.$addMenus = addMenus
    app.$addStore('main', stores)
    app.$addRoutes(system)
    Vue.prototype.$echarts = echarts
    app.$Message.config({
            duration: 3,
        })
        // 配置主题等静态文件资源
    xssFilter(Vue)
    linkStaticFile(store)
    Vue.use(encrypt)
    Vue.use(layout)
    Vue.use(commonComponents)
    Vue.use(customDirective, { store })
    Vue.use(ws, { store })
    let excludedModuleName = null
    for (let key in excludeCheckPath) {
        if (excludeCheckPath[key].includes(`${app.$route.path}`)) {
            excludedModuleName = key
        }
    }
    if (excludedModuleName) {
        app.$http
            .get(
                `/sctm/sctmresources/getResourceByResourceCode?resourceCode=${excludedModuleName}`
            )
            .then(({ data }) => {
                app
                    .$moduleLoader({
                        [excludedModuleName + '_ui']:
                            (envConst.MODULE_HOST || envConst.SCMCC_HOST) + data.bean,
                    })
                    .then(() => {
                        mountApp()
                    })
            })
    } else {
        if (router.currentRoute.query.accessToken) return mountApp()
        app.$http
            .get('/sctm/auth/getLoginState')
            .then((res) => {
                if (res.data.bean.msgCode === 0) {
                    getPreData({ app, store, exclude }).then((res) => {
                        console.log(res)
                        app.$moduleLoader(store.state.main.user.modules).then(() => {
                            // styleDemo&&styleDemo(Vue,pages,store)
                            app.$addRoutes(pages)
                            store.commit('main/setModulesCompleted', true)
                            app.$ws()
                            app.$config&&app.$config(ctx)
                            mountApp()
                        })
                    })
                } else {
                    localStorage.removeItem('user')
                    mountApp()
                }
                console.log(
                    `%cscmcc_ui%c模块加载完毕`,
                    'background: #00d1b2; padding: 5px; color: #fff; border-radius: 5px 0 0 5px',
                    'background: #555; padding: 5px; color: #fff; border-radius: 0 5px 5px 0'
                )
            })
            .catch((error) => {
                console.log(error)
                mountApp()
            })
    }

    function mountApp() {
        app.$mount('#app')
        const loaderNode = document.querySelector('.index-loader')
        if (loaderNode) loaderNode.style.display = 'none'
        document.querySelector('#app').style.display = 'block'
    }
}